import { MISTREATMENT } from '@/lib/enums'

const actions = {
  [MISTREATMENT.status.enum.OPENED]: ['start', 'reject'],
  [MISTREATMENT.status.enum.CHECKING]: ['done', 'cancel', 'openOsm'],
  [MISTREATMENT.status.enum.AWAITING_CONCLUSION]: ['done', 'cancel'],
  [MISTREATMENT.status.enum.CANCELED]: [],
}

export default (status) => actions[status] || []
